export var SPECS;
(function (SPECS) {
    SPECS["URL_CUSTOMIZE"] = "specs.stores.EnableUrlCustomizeInProductPage";
    SPECS["USE_LIGHTBOXES"] = "specs.stores.UseLightboxes";
    SPECS["SHOW_PRODUCT_PRICE_BREAKDOWN"] = "specs.stores.ShowProductPriceBreakdown";
    SPECS["SHOW_SHIPPING_DISCLAIMER"] = "specs.stores.ShowShippingDisclaimer";
    SPECS["PRICE_RANGE_VIEWER"] = "specs.stores.PriceRangeViewer";
    SPECS["USE_IS_OWNER_IN_CART_OOI"] = "specs.stores.UseIsOwnerInCartOOI";
    SPECS["ORDERS_API_FORCE_NODE_ONLY_RESPONSE"] = "specs.stores.OrdersApiForceNodeOnlyResponse";
    SPECS["USE_CHECKOUT_LEGACY_FOR_FAST_FLOW"] = "specs.stores.UseCheckoutLegacyForFastFlow";
    SPECS["CART_API_FAST_FLOW_WITH_CREATE_CHECKOUT"] = "specs.stores.CartApiFastFlowWithCreateCheckout";
})(SPECS || (SPECS = {}));
export var BI_STOREFRONT_VIEW_MODE;
(function (BI_STOREFRONT_VIEW_MODE) {
    BI_STOREFRONT_VIEW_MODE["SITE"] = "site";
    BI_STOREFRONT_VIEW_MODE["PREVIEW"] = "preview";
    BI_STOREFRONT_VIEW_MODE["EDITOR"] = "editor";
})(BI_STOREFRONT_VIEW_MODE || (BI_STOREFRONT_VIEW_MODE = {}));
export var BI_PRODUCT_OPTION_TYPE;
(function (BI_PRODUCT_OPTION_TYPE) {
    BI_PRODUCT_OPTION_TYPE["COLOR"] = "color";
    BI_PRODUCT_OPTION_TYPE["LIST"] = "list";
})(BI_PRODUCT_OPTION_TYPE || (BI_PRODUCT_OPTION_TYPE = {}));
export var BI_PRODUCT_OPTION_ACTION;
(function (BI_PRODUCT_OPTION_ACTION) {
    BI_PRODUCT_OPTION_ACTION["CHECKED"] = "checked";
    BI_PRODUCT_OPTION_ACTION["UNCHECKED"] = "unchecked";
})(BI_PRODUCT_OPTION_ACTION || (BI_PRODUCT_OPTION_ACTION = {}));
//# sourceMappingURL=constants.js.map